import request from '@/utils/request'


export function GetTopicList(params) {
    return request({
        url: '/api/HeartTopic/Load',
        method: 'get',
        params
    })
}

export function GetQuestionInfo(params) {
    return request({
        url: '/api/HeartQuestion/GetQuestionInfo',
        method: 'get',
        params
    })
}
// 提交测评
export function AddMore(topicId, userId, planId, data) {
    return request({
        url: '/api/HeartData/AddMore?topicId=' + topicId + '&userId=' + userId + '&planId=' + planId,
        method: 'post',
        data
    })
}

export function AddMoreTwo(url, data) {
    return request({
        url: url,
        method: 'post',
        data
    })
}



// 提交自测测评
export function AddMoreMy(topicId, userId, data) {
    return request({
        url: '/api/HeartData/AddMoreMy?topicId=' + topicId + '&userId=' + userId,
        method: 'post',
        data
    })
}

//获取自主健康测试列表
export function getAutoHealthyTestApi(params) {
    return request({
        url: '/api/HealthRecord/Load',
        method: 'get',
        params
    })
}

// 我的测评表 
export function getMyTaskEvaluationApi(params) {
    return request({
        url: '/api/HealthCenter/GetTopicList',
        method: 'get',
        params
    })
}
// 我的自测记录 
export function GetRecordList(params) {
    return request({
        url: '/api/HeartCenter/GetRecordList',
        method: 'get',
        params
    })
}
// 测评结果 
export function GetMyReport(params) {
    return request({
        url: '/api/HeartCenter/GetMyReport',
        method: 'get',
        params
    })
}
//测评记录
export function GetRecordDetail(params) {
    return request({
        url: '/api/HeartCenter/GetRecordDetail',
        method: 'get',
        params
    })
}

// 心里课堂 
export function HeartFileLoad(params) {
    return request({
        url: '/api/HeartFile/Load',
        method: 'get',
        params
    })
}
// 获取最新的心里课堂
export function GetNewListFileLoad(params) {
    return request({
        url: '/api/HeartFile/GetNewList',
        method: 'get',
        params
    })
}
// 心里咨询师
export function HeartTearchGetLoad(params) {
    return request({
        url: '/api/HeartTearch/Load',
        method: 'get',
        params
    })
}
// 咨询师详情
export function HeartTearchGet(params) {
    return request({
        url: '/api/HeartTearch/Get',
        method: 'get',
        params
    })
}


// 课程详情
export function HeartFileGet(params) {
    return request({
        url: '/api/HeartFile/Get',
        method: 'get',
        params
    })
}
// 添加提问 
export function HearConsultAdd(data) {
    return request({
        url: '/api/HeartConsult/Add',
        method: 'post',
        data
    })
}
export function HearConsultLoad(params) {
    return request({
        url: '/api/HeartConsult/Load',
        method: 'get',
        params
    })
}


export function HeartTopicGet(params) {
    return request({
        url: '/api/HeartTopic/Get',
        method: 'get',
        params
    })
}


// 排班计划
export function HeartScheduleGetSun(params) {
    return request({
        url: '/api/HeartSchedule/GetSun',
        method: 'get',
        params
    })
}

// 修改排班状态 
export function HeartScheduleUpdateStatus(params) {
    return request({
        url: '/api/HeartSchedule/UpdateStatus',
        method: 'get',
        params
    })
}

// 获取排班月份 

export function HeartScheduleGetMonth(params) {
    return request({
        url: '/api/HeartSchedule/GetMonth',
        method: 'get',
        params
    })
}
// 按照月份排班 
export function HeartScheduleAddMore(params) {
    return request({
        url: '/api/HeartSchedule/AddMore',
        method: 'get',
        params
    })
}

// 添加预约 
export function HeartCenterAddSchedule(params) {
    return request({
        url: '/api/HeartCenter/AddSchedule',
        method: 'get',
        params
    })
}

// 取消预约 
export function HeartCenterDeleteSchedule(params) {
    return request({
        url: '/api/HeartCenter/DeleteSchedule',
        method: 'get',
        params
    })
}

// 获取我的预约信息 
export function HeartCenterGetSchedule(params) {
    return request({
        url: '/api/HeartCenter/GetSchedule',
        method: 'get',
        params
    })
}
// 获取老师的预约信息 
export function HeartTearchGetScheduleList(params) {
    return request({
        url: '/api/HeartTearch/GetScheduleList',
        method: 'get',
        params
    })
}



// 咨询师回答列表
export function HeartConsultLoad(params) {
    return request({
        url: '/api/HeartConsult/Load',
        method: 'get',
        params
    })
}
// 问题回复列表
export function HeartConsultLoadAnswer(params) {
    return request({
        url: '/api/HeartPubConsult/LoadAnswer',
        method: 'get',
        params
    })
}
// 公开问题列表
export function HeartPubConsultLoad(params) {
    return request({
        url: '/api/HeartPubConsult/Load',
        method: 'get',
        params
    })
}
// 回答用户提问  
export function HearConsultUpdate(data) {
    return request({
        url: '/api/HeartConsult/Update',
        method: 'post',
        data
    })
}
// 回答用户提问2
export function HearConsultReply(params) {
    return request({
        url: '/api/HeartConsult/Reply',
        method: 'get',
        params
    })
}
// 公开回答问题
export function HeartPubConsultAddAnswer(params) {
    return request({
        url: '/api/HeartPubConsult/AddAnswer',
        method: 'get',
        params
    })
}

// 获取问答详情 
export function HearConsultGet(params) {
    return request({
        url: '/api/HeartConsult/Get',
        method: 'get',
        params
    })
}

// 获取公开问答详情 
export function HeartPubConsultGet(params) {
    return request({
        url: '/api/HeartPubConsult/Get',
        method: 'get',
        params
    })
}
// 获取回复详情 
export function HearConsultLoadAnswer(params) {
    return request({
        url: '/api/HeartPubConsult/LoadAnswer',
        method: 'get',
        params
    })
}

// 获取最新热文
export function GetHot(params) {
    return request({
        url: '/api/HeartPubConsult/GetHot',
        method: 'get',
        params
    })
}

// 获取最新热文
export function GetNewList(params) {
    return request({
        url: '/api/HeartPubConsult/GetNewList',
        method: 'get',
        params
    })
}

// 公开提问  
export function openAdd(data) {
    return request({
        url: '/api/HeartPubConsult/Add',
        method: 'post',
        data
    })
}

// 获取问题类型
export function GetByTypeId(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}

//修改密码
export function GetForgetPwd(params) {
    return request({
        url: '/api/PmiUser/ForgetPwd',
        method: 'get',
        params
    })
}

//获取验证码
export function GetSmsCode(params) {
    return request({
        url: '/api/PmiUser/GetSmsCode',
        method: 'get',
        params
    })
}

//我的消息列表
export function GetMesList(params) {
    return request({
        url: '/api/HeartCenter/GetMesList',
        method: 'get',
        params
    })
}

//民警消息数量
export function GetMesCount(params) {
    return request({
        url: '/api/HeartCenter/GetMesCount',
        method: 'get',
        params
    })
}

//民警新回复数量
export function UserCount(params) {
    return request({
        url: '/api/HeartConsult/UserCount',
        method: 'get',
        params
    })
}

//咨询师新回复数量
export function UserRead(params) {
    return request({
        url: '/api/HeartConsult/UserRead',
        method: 'get',
        params
    })
}

//咨询师待回复数量
export function TeacherCount(params){
    return request({
        url: '/api/HeartConsult/TeacherCount',
        method: 'get',
        params
    })
}

//消息已读
export function GetMesRead(params) {
    return request({
        url: '/api/HeartCenter/GetMesRead',
        method: 'get',
        params
    })
}

//记录点击量
export function ReadCount(params) {
    return request({
        url: '/api/HeartFile/ReadCount',
        method: 'get',
        params
    })
}

//获取报告文件
export function DownReport(params){
    return request({
        url: '/resource/HeartCenter/DownReport',
        method: 'get',
        params
    })
}

//获取体检机体检数据
export function getHealthyTestInfoNew(params){
    return request({
        url: '/api/HealthRecord/GetRecord',
        method: 'get',
        params
    })
}